const bannerTypes = [
    {value: 1, label: '图片'},
    {value: 2, label: '视频'},
];

const getBannerTypeText = function (type) {
    let res = bannerTypes.find(c => c.value == type);
    return res ? res.label : null;
}

export default {
    name: '轮播',
    url: '/admin/banner', // rest接口表名
    query: '&sort=sort', // rest接口query参数
    // 列表渲染列
    columns: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {title: '排序', dataIndex: 'sort'},
            {title: '图片/封面图', dataIndex: 'img', customRender: text => text ? <div class="photo-img"><img src={text} /></div> : '无'},
            {title: '轮播标题', dataIndex: 'title'},
            {title: '类别', dataIndex: 'type', customRender: text => getBannerTypeText(text)},
        ]
    },
    // 列表查询表单
    queryForm: [
        {
            key: 'title',
            label: '',
            component: 'a-input',
            props: {
                placeholder: '请输入标题搜索',
            },
        },
    ],
    // 新增/编辑查询表单
    items: [
        {
            key: 'title',
            label: '轮播标题',
            component: 'a-input',
            props: {
                placeholder: '请输入轮播标题',
            },
            rules: [{ required: true, message: '请输入轮播标题', trigger: 'blur' }]
        },
        {
            key: 'type',
            label: '轮播类型',
            component: 'a-radio-group',
            props: {
                options: bannerTypes,
                placeholder: "请选择轮播类型"
            },
            listeners: {
                change(e) {
                    const val = e.target.value;
                    const i = this.controls.findIndex(c => c.key == 'img');
                    const con = this.controls[i];
                    if(con) {
                        this.$set(con, 'label', val == 1 ? '轮播图片' : '视频封面');
                    }
                    const j = this.controls.findIndex(c => c.key == 'video');
                    if (val == 1) {
                        if (j >= 0) {
                            this.controls.splice(j, 1);
                        }
                    } else {
                        if(j === -1) {
                            this.controls.splice(i + 1, 0, {
                                key: 'video',
                                label: '视频上传',
                                component: 'form-upload',
                                props: {
                                    mediaType: 'video',
                                    limit: 1,
                                    size: 30 * 1024,
                                    tip: "建议视频尺寸1920*1080，支持mp4格式，小于30M"
                                },
                                rules: [{ required: true, message: '请上传视频', trigger: 'change' }]
                            });
                        }
                    }
                }

            },
            rules: [{ required: true, message: '请选择轮播类型', trigger: 'change' }]
        },
        {
            key: 'img',
            label: '轮播图片',
            component: 'form-upload',
            props: {
                limit: 1,
                size: 2 * 1024,
                tip: "1920*1080像素，支持png、jpg格式，小于2M"
            },
            rules: [{ required: true, message: '请上传轮播图片', trigger: 'change' }]
        },
        {
            key: 'link',
            label: '跳转链接',
            component: 'a-input',
            props: {
                placeholder: '请输入跳转链接',
            },
        },
        {
            key: 'sort',
            label: '排序',
            component: 'a-input-number',
            props: {
                placeholder: '数字越小，排位越前',
            },
            style: {
                width: '100%'
            }
        }
    ],
    // 详情接口expand字段
    expand: '',
    init: {type: 1}, // 新增实体初始化字段
    // 详情渲染字段
    renderItems: (ctx, detail) => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement;
        const res = [
            {
                label: '轮播标题',
                key: 'title',
            },
            {
                label: '轮播类型',
                slot: entity => <span>{getBannerTypeText(entity.type)}</span>
            },
        ];
        if (detail.type == 1) {
            res.push({
                label: '轮播图片',
                key: 'img',
                img: true
            });
        } else {
            res.push({
                label: '轮播视频',
                key: 'media',
                media: true
            });
        }
        res.push(
            {
                label: '跳转链接',
                key: 'link',
            },
            {
                label: '排序',
                key: 'sort',
            }
        )
        return res;
    },
    dealDetail: function(detail) {
        return new Promise(resolve => {
            if(detail.type == 2) {
                detail.media = [{ type: 'video', url: detail.video, poster: detail.img}];
            }
            resolve(detail);
        });
    }
}
